import { Injectable } from '@angular/core';
import { BaseIndexedDbService } from "@core/storage/indexedDb/_database.service";
import { STORAGE_KEYS } from "@core/storage/indexedDb/_database.constants";
import { TravelDocumentRequest } from "@api/api";

@Injectable({
  providedIn: 'root',
})
export abstract class TravelDocumentIndexedDbService extends BaseIndexedDbService<TravelDocumentRequest> {
  override objectStoreName = STORAGE_KEYS.travelDocument;
}
